import React from "react";

import CartContainer from "./CartContainer";

const Cart = () => {
  return <CartContainer />;
};

export default Cart;
